import axios from 'axios';
import qs from 'query-string';

const _axios = axios.create( {

} );

export const AUTOCOMPLETE = 'AUTOCOMPLETE';

export const wsFindByCatalogNumber = ( catalogNumber ) => {
    const params = {
        catalogNumber
    };
    return _axios.post( '/api/v1/search/findByCatalogNumber', qs.stringify( params ) );
};

/* TODO - this part seems to be horific 
 * I dont know what is the expected result, it changing manytimes
 * Write with types, when you will know what is the result
 * right now, i am selecting results from our db + merging the results from gogole. 
 */
const parseSectors = ( items ) => {
    //no results from google
    if ( !items ) {
        return [ ];
    }
    //find necessary data for sectors
    return items.filter( item => item.pagemap.metatags[0].flagproductsector === "true" )
            .map( item => {
                return {
                    'sectorName': item.pagemap.metatags[0].sectorname,
                    'catalogName': item.pagemap.metatags[0].catalogname,
                    'sectorUrl': item.formattedUrl
                };
            } );
};

const parseProducts = ( items ) => {
    //no results from google
    if ( !items ) {
        return [ ];
    }
    //find necessary data for products
    return items.filter( item => item.pagemap.metatags[0].flagproductdetail === "true" )
            .map( item => {
                return {
                    'id': item.pagemap.metatags[0].catalognumber,
                    'catalogNumber': item.pagemap.metatags[0].catalognumber,
                    'priceWithVat': parseFloat( item.pagemap.metatags[0].pricewithvat ),
                    'duelId': item.pagemap.metatags[0].duelid,
                    'stockQty': item.pagemap.metatags[0].stockqty,
                    'productName': item.pagemap.metatags[0].productname,
                    'productUrl': item.formattedUrl,
                    'variantsProductArr': [ ]
                };
            } );
};

const parsePages = ( items ) => {
    //no results from google
    if ( !items ) {
        return [ ];
    }
    //find necessary data for products
    return items.filter( item => ( !item.pagemap.metatags[0].flagproductdetail && !item.pagemap.metatags[0].flagproductsector ) )
            .map( item => {
                return {
                    'url': item.link,
                    'title': item.title,
                    'snippet': item.snippet
                };
            } );
};

const googleSearchApiResults2Results = ( googleSearchApiResponse ) => {

    const sectorArr = parseSectors( googleSearchApiResponse.items );
    const productArr = parseProducts( googleSearchApiResponse.items );
    const pageArr = parsePages( googleSearchApiResponse.items ).slice( 0, 3 ); //only 3 items - better when there will be a products

    const retval = {
        "query": googleSearchApiResponse.queries.request[0].searchTerms,
        "sectors": sectorArr,
        "sectorsCount": sectorArr.length,
        "products": productArr,
        "productsCount": parseInt( googleSearchApiResponse.searchInformation.totalResults ),
        "pages": pageArr,
        "pagesCount": pageArr.length
    };

    return retval;
};

// google search api solution
export const autocomplete = ( query ) => async dispatch => {

        try {
            //try bbb search
            const responseBBB = await _axios.post( '/api/v1/search/autocomplete', qs.stringify( { query } ) );
            let data = responseBBB.data;
            data.searchSource = "BBB only search";

            //In case own search found nothing - try google search
            if( data.productsCount === 0 ){
                const responseGoogle = await _axios.get( `https://www.googleapis.com/customsearch/v1?key=AIzaSyARkhSDHWcH8vnQXOCq4llE9HU2iVTSnGk&cx=012746493875132912547:zbecc7byxls&q=${query}` );
                data = googleSearchApiResults2Results( responseGoogle.data );
                data.searchSource = "Google extended search";
            }
            
            dispatch( { type: AUTOCOMPLETE, payload: data } );

        } catch ( error ) {
            console.error( error );
        }
    };

export const resetAutocomplete = () => async dispatch => {
        dispatch( { type: AUTOCOMPLETE, payload: false } );
    };
